import { useEffect, useContext } from "react";
import DashboardLayout from "../dashboard_layouts";
import { AuthContext } from "../util/api";
import { useNavigate } from "react-router-dom";
import DoctorDashDetails from "./DoctorDashDetails";
import Navbar from "../header";
import Footer from "../footer";

export default function DoctorsDashboard() {

    const { token, User } = useContext(AuthContext);
    const router = useNavigate();

    useEffect(() => {
        if (User == null || token == null) {
            router('/login');
        } else if (User.is_verified === false) {
            router('/doctor-profile-reg');
        }

    }, []);


    return (

        <>
            <Navbar menuColor="red" />
            <section >
                <DoctorDashDetails />

            </section>

            <Footer />
            {/*   <DashboardLayout></DashboardLayout>   */}

        </>
    );
}